import { ChangeDetectorRef, Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';
import { SolicitudService } from '../../datosbasicos/datosbasicos.service';
import { SolicitudViewModel, TImportadorViewModel } from '../../datosbasicos/datosbasicos.types';
import { BuscadorCodigoConfeccionListComponent } from '../../components/popup/codigoConfeccion/buscador-codigoconfeccion-list.component';
import { EnumIdsTcPais, TcPaisUsaCodigoPostal } from '../../../../core/_infrastructure/types/common';
import { Observable } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { BuscadorOperadorListComponent } from '../../components/popup/operador/buscadoroperador-list.component';
import { CustomValidator } from '../../../../core/_infrastructure/classes/customValidator';
import { EnumIdsTcEstadoSolicitud, EnumIdsTwTcTipoTransbordo } from '../../types/enum';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { RegistroSanitarioService } from '../../../../_mantenimiento/registros/registrosanitario/registrosanitario.service';
import { CodigoConfeccionImportacionViewModel } from '../../../../_mantenimiento/registros/registrosanitario/registrosanitario.types';

@Component({
    selector: 'app-importador',
    templateUrl: './importador.component.html',
    styleUrls: ['./importador.component.scss'],
})
export class ImportadorComponent extends ComponentBase implements OnInit, OnChanges {
    @ViewChild(BuscadorOperadorListComponent) private buscadorOperadoresPopup: BuscadorOperadorListComponent;
    @ViewChild(BuscadorCodigoConfeccionListComponent) private buscadorCodigoConfeccionPopup: BuscadorCodigoConfeccionListComponent;

    @Input() formGroup: FormGroup;
    @Input() edicionManual = false;
    @Input() validacionRegistroImportadores = false;
    @Input() validacionEupoEurpo = false;
    @Input() validacionRegistroSanitario = false;
    @Input() solicitud: SolicitudViewModel;
    @Input() habilitarGuardar = false;
    @Input() enviada = false;
    @Input() esPasajeros = false;
    @Input() esPredua = false;
    @Input() esPrevia = false;
    @Input() esTransitoDirecto = false;
    @Input() esTransbordo = false;
    @Input() esTraslado = false;
    @Input() esClonada = false;
    @Input() esProductosFitosanitarios = false;
    @Input() esImportadorExtranjero = false;
    @Input() tieneLugarDestinoImpor = false;
    @Input() campoObligatorio = true;
    @Input() readonlyImporExtr = true;
    @Input() usaCodigoPostalPaisImportador = true;
    @Input() habilitarBuscarOperador = true;
    @Input() isCanariasPifCanarias = false;
    @Input() isConfiguracionPcfCanariasNoTraces = false;
    @Input() nombreImportadorRequired = false;
    @Input() listPaisImportador: TcPaisUsaCodigoPostal[];
    @Input() tieneProductos = false;
    @Input() idPaisTraslado: number;

    @Output() registroSanitarioToDeleteByIdSolicitud = new EventEmitter<number>();
    @Output() formularioActualizado = new EventEmitter<boolean>();

    isCollapsedCabeceraImp = false;
    visibilitySpinner = false;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private cdr: ChangeDetectorRef,
        private solicitudService: SolicitudService,
        private confirmationService: ConfirmationService,
        private globalService: GlobalService,
        private registroSanitarioService: RegistroSanitarioService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.updateForm();
        this.hayRegistroSanitario;

        // Si es Tránsito Directo o Transbordo vendrá precargado el valor del IdPaisImportador con el que se haya elegido en el País de Destino en el Lugar de Mercancía
        if ((this.esTransitoDirecto || this.esTransbordo) && this.solicitud.EsExtranjero) {
            if (this.solicitud.TLugarMercancia.IdPaisDestino !== null || this.solicitud.TLugarMercancia.IdPaisDestino !== undefined) {
                this.form.patchValue({
                    IdPaisImportador: this.solicitud.TLugarMercancia.IdPaisDestino,
                });
            }
        } else if (!this.solicitud.EsExtranjero) {
            this.form.patchValue({
                IdPaisImportador: EnumIdsTcPais.ID_ESPANA,
            });
        }

        if (this.esImportadorExtranjero) {
            this.addValidator('Nombre', Validators.required);
            //this.removeValidators('NRegistro'); Por defecto se quita la validación en la definición
            this.addValidator('IdPaisImportador', Validators.required);
        } else {
            this.addValidator('NIF', CustomValidator.NIFValidator);

            //Se quita temporalmente confirmado con Tomás y como no se actualiza bien el valor de este Input
            if (!this.edicionManual) {
                this.addValidator('NRegistro', Validators.required); // y se añade si es NIF Nacional pero sin edición manual (Higiene)
            }

            // Si el Importador no es Extranjero entonces es obligatorio el Código Postal
            this.addValidator('CodigoPostalImportador', Validators.required);
            this.usaCodigoPostalPaisImportador = true; // Esta variable se usa en el html para la Label
        }

        if (this.esPrevia && this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA && !this.enviada) {
            this.RemoveValidationsPrevia();
        }

        if (this.validacionRegistroSanitario === false) {
            this.removeValidators('RegistroSanitario');
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.solicitud?.currentValue) {
            this.solicitud = { ...changes.solicitud?.currentValue };
            this.updateForm();
        }

        if (changes.validacionRegistroSanitario?.currentValue === true && this.esPrevia === false && !this.esPasajeros) {
            this.addValidator('RegistroSanitario', Validators.required);
        }

        if (changes.edicionManual?.currentValue) {
            this.edicionManual = changes.edicionManual.currentValue;

            if (!this.esImportadorExtranjero) {
                if (!this.edicionManual) {
                    this.addValidator('NRegistro', Validators.required); // y se añade si es NIF Nacional pero sin edición manual (Higiene)
                } else {
                    this.removeValidators('NRegistro');
                }
            }
        }
    }

    private updateForm(): void {
        let nregistro;
        // Si es Pasajeros o Productos Fitosanitarios
        if (this.esPasajeros || this.esProductosFitosanitarios) {
            nregistro = 'No Registrado';
        } else {
            nregistro = this.solicitud.TImportador?.NRegistro;
        }

        this.formGroup.patchValue({
            NRegistro: nregistro,
        });

        if (this.solicitud.TImportador !== null) {
            this.formGroup.patchValue({
                NIF: this.solicitud.TImportador.Nif,
                RefTraces: this.solicitud.TImportador.RefTraces,
                OperadorTraces: this.solicitud.TImportador.OperadorTraces,
                TipoOperador: this.solicitud.TImportador.TipoOperador,
                Nombre: this.solicitud.TImportador.Nombre,
                Direccion: this.solicitud.TImportador.Direccion,
                Localidad: this.solicitud.TImportador.Localidad,
                CodigoPostalImportador: this.solicitud.TImportador.CodigoPostalImportador,
                IdPaisImportador: this.solicitud.TImportador.IdPaisImportador,
                IdRegistroSanitario: this.solicitud.TImportador != null ? this.solicitud.TImportador.IdRegistroSanitario : null,
                RegistroSanitario: this.solicitud.TImportador != null ? this.solicitud.TImportador.RegistroSanitario : null,
                RazonSocialRegistroSanitario: this.solicitud.TImportador != null ? this.solicitud.TImportador.RazonSocialRegistroSanitario : null,
                DireccionRegistroSanitario: this.solicitud.TImportador != null ? this.solicitud.TImportador.DireccionRegistroSanitario : null,
                MunicipioRegistroSanitario: this.solicitud.TImportador != null ? this.solicitud.TImportador.MunicipioRegistroSanitario : null,
                ProvinciaRegistroSanitario: this.solicitud.TImportador != null ? this.solicitud.TImportador.ProvinciaRegistroSanitario : null,
            });
        }

        // Si tiene Registro Sanitario
        if (
            this.solicitud.TImportador?.RegistroSanitario !== null &&
            this.solicitud.TImportador?.RegistroSanitario !== '' &&
            this.solicitud.TImportador?.RegistroSanitario !== undefined
        ) {
            this.registroSanitarioService.getRegistroSanitarioById(this.solicitud.TImportador.IdRegistroSanitario!).subscribe(res => {
                this.form.patchValue({
                    //RegistroSanitario: res.RegistroSanitario,
                    RazonSocialRegistroSanitario: res.RazonSocial,
                    DireccionRegistroSanitario: res.Direccion,
                    MunicipioRegistroSanitario: res.Municipio,
                    ProvinciaRegistroSanitario: res.Provincia,
                });
            });
        }

        // Hacemos el subscribe manual y no lo delegamos al async del HTML, volcamos a array de objetos para acceder al valor de ciertas columnas al seleccionar un elemento
        if (!this.esTransitoDirecto && !this.esTransbordo) {
            // Si 'tieneLugarDestinoImpor' va a entrar por aquí SIEMPRE por el tipo
            this.globalService.getAllPaisesUeTcUsaCodigoPostal().subscribe(res => {
                this.listPaisImportador = res;
                // País Importador
                if (this.esImportadorExtranjero) {
                    if (!(this.esPrevia && this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA && !this.enviada)) {
                        let idPaisImportador: number;
                        if (this.form.controls['IdPaisImportador']?.value === null || this.form.controls['IdPaisImportador']?.value === undefined) {
                            idPaisImportador = this.solicitud.TLugarMercancia.IdPaisDestino!;
                        } else {
                            idPaisImportador = this.form.controls['IdPaisImportador']?.value;
                        }

                        let seleccionado = this.listPaisImportador?.find(x => x.Id == idPaisImportador);
                        if (seleccionado != null && seleccionado != undefined) {
                            this.usaCodigoPostalPaisImportador = (<TcPaisUsaCodigoPostal>seleccionado).UsaCodigoPostal;
                            this.habilitarBuscarOperador = (<TcPaisUsaCodigoPostal>seleccionado).EsUnionEuropea && !this.esPasajeros;
                        } else {
                            this.habilitarBuscarOperador = !this.esPasajeros;
                            this.usaCodigoPostalPaisImportador = true; // RDLF: Por defecto que sea obligatorio, por problemas con las de Canarias CF PREDUA
                        }
                        if (this.usaCodigoPostalPaisImportador!.valueOf() == true) {
                            this.addValidator('CodigoPostalImportador', Validators.required);
                        } else {
                            this.removeValidators('CodigoPostalImportador');
                        }
                    }
                }
            });
        } else {
            if (this.esTransitoDirecto) {
                // Tránsitos Directos
                // RDLF: 29/10/24 se añade España para los Tránsitos Directos (Tarea #145949)
                this.globalService.getAllPaisesNoUeConSpainTcUsaCodigoPostal().subscribe(res => {
                    this.listPaisImportador = res;
                    // País Importador
                    if (this.esImportadorExtranjero) {
                        if (!(this.esPrevia && this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA && !this.enviada)) {
                            let idPaisImportador: number;
                            if (this.form.controls['IdPaisImportador']?.value === null || this.form.controls['IdPaisImportador']?.value === undefined) {
                                idPaisImportador = this.solicitud.TLugarMercancia.IdPaisDestino!;
                            } else {
                                idPaisImportador = this.form.controls['IdPaisImportador']?.value;
                            }

                            let seleccionado = this.listPaisImportador?.find(x => x.Id == idPaisImportador);
                            if (seleccionado != null && seleccionado != undefined) {
                                this.usaCodigoPostalPaisImportador = (<TcPaisUsaCodigoPostal>seleccionado).UsaCodigoPostal;
                                this.habilitarBuscarOperador = (<TcPaisUsaCodigoPostal>seleccionado).EsUnionEuropea && !this.esPasajeros;
                            } else {
                                this.habilitarBuscarOperador = false;
                                this.usaCodigoPostalPaisImportador = true; //RDLF: por defecto que sea obligatorio, por problemas con las de Canarias CF PREDUA
                            }
                            if (this.usaCodigoPostalPaisImportador!.valueOf() == true) {
                                this.addValidator('CodigoPostalImportador', Validators.required);
                            } else {
                                this.removeValidators('CodigoPostalImportador');
                            }
                        }
                    }
                });
            } else {
                // Transbordos
                if (this.solicitud.TwTransbordo.IdTipoTransbordo == EnumIdsTwTcTipoTransbordo.ID_A_TERCER_PAIS) {
                    // A Tercer País
                    // RDLF: Tomás pide que estos paises, para estas solicitudes, sean NO UE (02/11/2023)
                    this.globalService.getAllPaisesNoUeTcUsaCodigoPostal().subscribe(res => {
                        this.listPaisImportador = res;
                        // País Importador
                        if (this.esImportadorExtranjero) {
                            if (!(this.esPrevia && this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA && !this.enviada)) {
                                let idPaisImportador: number;
                                if (this.form.controls['IdPaisImportador']?.value === null || this.form.controls['IdPaisImportador']?.value === undefined) {
                                    idPaisImportador = this.solicitud.TLugarMercancia.IdPaisDestino!;
                                } else {
                                    idPaisImportador = this.form.controls['IdPaisImportador']?.value;
                                }

                                let seleccionado = this.listPaisImportador?.find(x => x.Id == idPaisImportador);
                                if (seleccionado != null && seleccionado != undefined) {
                                    this.usaCodigoPostalPaisImportador = (<TcPaisUsaCodigoPostal>seleccionado).UsaCodigoPostal;
                                    this.habilitarBuscarOperador = (<TcPaisUsaCodigoPostal>seleccionado).EsUnionEuropea && !this.esPasajeros;
                                } else {
                                    this.habilitarBuscarOperador = false;
                                    this.usaCodigoPostalPaisImportador = true; // RDLF: por defecto que sea obligatorio, por problemas con las de Canarias CF PREDUA
                                }
                                if (this.usaCodigoPostalPaisImportador!.valueOf() == true) {
                                    this.addValidator('CodigoPostalImportador', Validators.required);
                                } else {
                                    this.removeValidators('CodigoPostalImportador');
                                }
                            }
                        }
                    });
                } else {
                    // A PCF_UE
                    this.globalService.getAllPaisesTcUsaCodigoPostal().subscribe(res => {
                        this.listPaisImportador = res;
                        // País Importador
                        if (this.esImportadorExtranjero) {
                            this.habilitarBuscarOperador = false;

                            if (!(this.esPrevia && this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA && !this.enviada)) {
                                let idPaisImportador: number;
                                if (
                                    this.form.controls['IdPaisImportador']?.value === null &&
                                    this.form.controls['IdPaisImportador']?.value === undefined &&
                                    this.form.controls['IdPaisImportador']?.value === ''
                                ) {
                                    idPaisImportador = this.solicitud.TLugarMercancia.IdPaisDestino!;
                                } else {
                                    idPaisImportador = this.form.controls['IdPaisImportador']?.value;
                                }

                                let seleccionado = this.listPaisImportador?.find(x => x.Id == idPaisImportador);

                                if (seleccionado != null && seleccionado != undefined) {
                                    this.usaCodigoPostalPaisImportador = (<TcPaisUsaCodigoPostal>seleccionado).UsaCodigoPostal;
                                    // this.habilitarBuscarOperador = (<TcPaisUsaCodigoPostal>seleccionado).EsUnionEuropea && !this.esPasajeros;
                                } else {
                                    // this.habilitarBuscarOperador = false;
                                    this.usaCodigoPostalPaisImportador = true; //RDLF: por defecto que sea obligatorio, por problemas con las de Canarias CF PREDUA
                                }
                                if (this.usaCodigoPostalPaisImportador!.valueOf() == true) {
                                    this.addValidator('CodigoPostalImportador', Validators.required);
                                } else {
                                    this.removeValidators('CodigoPostalImportador');
                                }
                            }
                        }
                    });
                }
            }
        }

        this.form = this.formGroup;

        this.cdr.detectChanges();

        this.hayRegistroSanitario;

        this.formularioActualizado.emit(true);
    }

    onSelectPaisImportador(): void {
        const idPais = this.form.controls['IdPaisImportador'].value; //this.form.value.IdPaisImportador;
        let seleccionado = this.listPaisImportador?.find(x => x.Id == idPais);
        if (seleccionado != null) {
            this.usaCodigoPostalPaisImportador = (<TcPaisUsaCodigoPostal>seleccionado).UsaCodigoPostal;
            this.habilitarBuscarOperador =
                (<TcPaisUsaCodigoPostal>seleccionado).EsUnionEuropea && !this.esPasajeros && !this.esTransitoDirecto && !this.esTransbordo;
        } else {
            this.habilitarBuscarOperador = false;
        }
        if (this.usaCodigoPostalPaisImportador!.valueOf() == true) {
            this.addValidator('CodigoPostalImportador', Validators.required);
        } else {
            this.removeValidators('CodigoPostalImportador');
        }

        // RDLF -> Limpio campos no editables para que no se pueda cambiar de país manteniendo otros datos de Traces si no es de tipo transito directo, transbordo o pasajeros
        // emarti69: Si es 'Edición manual' no se limpian los campos
        if (!this.esTransitoDirecto && !this.esTransbordo && !this.esPasajeros && !this.edicionManual) {
            this.form.patchValue({
                Nombre: '',
                Direccion: '',
                Localidad: '',
                CodigoPostalImportador: '',
                RefTraces: '',
                TipoOperador: '',
                RegistroSanitario: '',
                RazonSocialRegistroSanitario: '',
                DireccionRegistroSanitario: '',
                MunicipioRegistroSanitario: '',
                ProvinciaRegistroSanitario: '',
            });
        }
    }

    onSearchNif(): void {
        if (!this.form.controls.NIF.valid || this.form.value.NIF == '') {
            this.form.patchValue({
                NRegistro: '',
                Nombre: '',
                Direccion: '',
            });
        } else {
            this.getRegistroImportadores().subscribe({
                next: result => {
                    if (result.Nif != '' && result.NRegistro != '') {
                        if (result.Apellidos == null || result.Apellidos == '') {
                            this.form.patchValue({
                                NRegistro: result.NRegistro,
                                Nombre: result.Nombre,
                                Direccion: result.Direccion,
                                OperadorTraces: result.OperadorTraces,
                                TipoOperador: result.TipoOperador,
                                RefTraces: result.RefTraces,
                                TipoRefTraces: result.TipoRefTraces,
                            });
                        } else {
                            this.form.patchValue({
                                NRegistro: result.NRegistro,
                                Nombre: result.Nombre + ' ' + result.Apellidos,
                                Direccion: result.Direccion,
                                OperadorTraces: result.OperadorTraces,
                                TipoOperador: result.TipoOperador,
                                RefTraces: result.RefTraces,
                                TipoRefTraces: result.TipoRefTraces,
                            });
                        }

                        //// Si tieneLugarDestinoImpor se pregunta si se rellenan sus datos también (Pedido por Tomás #121867)
                        //// emarti69: Se comenta esta parta a raíz de la tarea #170033
                        //if (this.tieneLugarDestinoImpor) {
                        //    this.confirmationService.confirm({
                        //        message: '¿Quiere rellenar con estos datos el "Lugar de destino"?',
                        //        accept: () => {
                        //            this.form.patchValue({
                        //                NIFImpLugarDestino: this.form.value.NIF,
                        //                NRegistroImpLugarDestino: this.form.value.NRegistro,
                        //                NombreImpLugarDestino: this.form.value.Nombre,
                        //                DireccionImpLugarDestino: this.form.value.Direccion,
                        //                OperadorTracesImpLugarDestino: this.form.value.OperadorTraces,
                        //                TipoOperadorImpLugarDestino: this.form.value.TipoOperador,
                        //                RefTracesImpLugarDestino: this.form.value.RefTraces,
                        //                TipoRefTracesImpLugarDestino: this.form.value.TipoRefTraces,
                        //                LocalidadImpLugarDestino: this.form.value.Localidad,
                        //                CodigoPostalImpLugarDestino: this.form.value.CodigoPostalImportador,
                        //            });
                        //        },
                        //    });
                        //}
                    }
                },
                error: error => {
                    if (error?.error instanceof Array) {
                        if (error?.error?.length > 0) {
                            if (error?.error[0].key === 'CommunicationException') {
                                this.addErrorMessage('No se ha podido establecer conexión con el Registro de Importadores. Vuelva a intentarlo más tarde.');
                            }
                        }
                    } else {
                        this.catchServerError(error);
                    }
                },
            });
        }
    }

    onChangeNif(): void {
        //rdlf -> limpio campos no editables para que no se pueda cambiar de NIF manteniendo otros datos de Registro Importadores y Traces
        this.form.patchValue({
            //NRegistro: '',
            Nombre: '',
            Direccion: '',
            RefTraces: '',
            OperadorTraces: '',
            TipoOperador: '',
        });
    }

    private getRegistroImportadores(): Observable<TImportadorViewModel> {
        if (this.isCanariasPifCanarias || this.esPasajeros || this.isConfiguracionPcfCanariasNoTraces) {
            return this.solicitudService.getRegistroImportadoresNoTraces(this.form.value.NIF);
        } else {
            return this.solicitudService.getRegistroImportadores(this.form.value.NIF);
        }
    }

    onSearchOperador(): void {
        this.buscadorOperadoresPopup.showDialog(false, this.form.value.IdPaisImportador, this.esTransitoDirecto, this.esTraslado, this.idPaisTraslado);
    }

    onAceptDialogBuscadorOperadores(importador: TImportadorViewModel): void {
        this.form.patchValue({
            Nombre: importador.Nombre,
            Direccion: importador.Direccion,
            Localidad: importador.Localidad,
            CodigoPostalImportador: importador.CodigoPostalImportador,
            IdPaisImportador: importador.IdPaisImportador,
            RefTraces: importador.RefTraces,
            TipoRefTraces: importador.TipoRefTraces,
            OperadorTraces: importador.OperadorTraces,
            TipoOperador: importador.TipoOperador,
        });

        if (importador.TipoRefTraces == 'eori') {
            this.form.patchValue({
                NIF: importador.RefTraces,
            });
        } else {
            this.form.patchValue({
                NIF: '',
            });
        }

        //// Si tieneLugarDestinoImpor se pregunta si se rellenan sus datos también (Pedido por Tomás #121867)
        //// emarti69: Se comenta esta parta a raíz de la tarea #170033
        //if (this.tieneLugarDestinoImpor) {
        //    this.confirmationService.confirm({
        //        message: '¿Quiere rellenar con estos datos el "Lugar de destino"?',
        //        accept: () => {
        //            this.form.patchValue({
        //                //NRegistroImpLugarDestino: this.form.value.NRegistro,
        //                NombreImpLugarDestino: this.form.value.Nombre,
        //                DireccionImpLugarDestino: this.form.value.Direccion,
        //                OperadorTracesImpLugarDestino: this.form.value.OperadorTraces,
        //                TipoOperadorImpLugarDestino: this.form.value.TipoOperador,
        //                RefTracesImpLugarDestino: this.form.value.RefTraces,
        //                TipoRefTracesImpLugarDestino: this.form.value.TipoRefTraces,
        //                LocalidadImpLugarDestino: this.form.value.Localidad,
        //                CodigoPostalImpLugarDestino: this.form.value.CodigoPostalImportador,
        //                IdPaisImpLugarDestino: this.form.value.IdPaisImportador,
        //                NIFImpLugarDestino: this.form.value.NIF,
        //            });
        //            if (this.solicitud.TImportadorLugarDestino == null) {
        //                this.solicitud.TImportadorLugarDestino = new TImportadorLugarDestinoViewModel();
        //            }
        //        },
        //    });
        //}
    }

    onAceptDialogBuscadorCodigoConfeccionImportacion(codigoConfeccionImportacion: CodigoConfeccionImportacionViewModel): void {
        this.form.patchValue({
            IdRegistroSanitario: codigoConfeccionImportacion.Id,
            RegistroSanitario: codigoConfeccionImportacion.RegistroSanitario,
            RazonSocialRegistroSanitario: codigoConfeccionImportacion.RazonSocial,
            DireccionRegistroSanitario: codigoConfeccionImportacion.Direccion,
            MunicipioRegistroSanitario: codigoConfeccionImportacion.Municipio,
            ProvinciaRegistroSanitario: codigoConfeccionImportacion.Provincia,
        });

        //// emarti69: Se comenta esta parta a raíz de la tarea #170033
        //if (this.tieneLugarDestinoImpor) {
        //    this.confirmationService.confirm({
        //        message: '¿Quiere rellenar con este Registro Sanitario el "Lugar de destino"?',
        //        accept: () => {
        //            this.form.patchValue({
        //                IdRegistroSanitarioImpLugarDestino: codigoConfeccionImportacion.Id,
        //                RegistroSanitarioImpLugarDestino: codigoConfeccionImportacion.RegistroSanitario,
        //                RazonSocialRegistroSanitarioImpLugarDestino: codigoConfeccionImportacion.RazonSocial,
        //                DireccionRegistroSanitarioImpLugarDestino: codigoConfeccionImportacion.Direccion,
        //                MunicipioRegistroSanitarioImpLugarDestino: codigoConfeccionImportacion.Municipio,
        //                ProvinciaRegistroSanitarioImpLugarDestino: codigoConfeccionImportacion.Provincia,
        //            });
        //            if (this.solicitud.TImportadorLugarDestino == null) {
        //                this.solicitud.TImportadorLugarDestino = new TImportadorLugarDestinoViewModel();
        //            }
        //        },
        //    });
        //}
    }

    onSearchCodigoConfeccionImportacion(): void {
        this.buscadorCodigoConfeccionPopup.showDialog(false);
    }

    onDeleteCodigoConfeccionImportacion() {
        if (this.form.value.RegistroSanitario === this.solicitud.TImportador?.RegistroSanitario) {
            let idSolicitud = this.solicitud.Id;
            this.registroSanitarioToDeleteByIdSolicitud.emit(idSolicitud);
        } else if (
            this.form.value.RegistroSanitario !== this.solicitud.TImportador?.RegistroSanitario ||
            this.solicitud.TImportador?.RegistroSanitario === null
        ) {
            // Si el Registro Sanitario guardado en bbdd es diferente del que se muestra en el formulario es que aún no lo ha registrado, por tanto con limpiar el formulario será suficiente
            this.form.patchValue({
                IdRegistroSanitario: null,
                RegistroSanitario: null,
                RazonSocialRegistroSanitario: '',
                DireccionRegistroSanitario: '',
                MunicipioRegistroSanitario: '',
                ProvinciaRegistroSanitario: '',
            });
        }
    }

    get hayRegistroSanitario(): boolean {
        return this.form.value.RegistroSanitario !== '' && this.form.value.RegistroSanitario !== null && this.form.value.RegistroSanitario !== undefined;
    }

    private RemoveValidationsPrevia(): void {
        // Importador
        this.removeValidators('NIF');
        this.removeValidators('Nombre');
        this.removeValidators('NRegistro');
        this.removeValidators('Localidad');
        this.removeValidators('CodigoPostalImportador');
        this.removeValidators('IdPaisImportador');
        this.removeValidators('Direccion');
        this.removeValidators('RegistroSanitario');
    }
}
